import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../../ui/common/button";

interface WastePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/**
 * Simple prev/next page navigation for the waste record list.
 * Renders nothing when there is only one page.
 */
export const WastePagination = ({
  currentPage,
  totalPages,
  onPageChange
}: WastePaginationProps) => {
  // Return null instead of wrapping in a guard at the call site.
  if (totalPages <= 1) return null;

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pt-1">
      <Button
        variant="ghost"
        size="icon"
        className="tw-h-7 tw-w-7"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeft className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <span className="tw-text-[10px] tw-text-muted-foreground tw-font-mono">
        {currentPage} / {totalPages}
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="tw-h-7 tw-w-7"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ChevronRight className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );
};
